import {MultiSelectRowHeader} from "./MultiSelectRowHeader";
import React, {useContext, useState} from "react";
import {ListItemText, MenuItem} from "@mui/material";
import {ConfirmContext} from "../../../../misc/Confirm";
import {api} from "../../../../api/API";
import {useSnackbar} from "../../../../misc/Snackbar";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {red} from "@mui/material/colors";
import {MoveSelectedOpenings} from "./MoveSelectedOpenings";
import {SetByOthers} from "../../shopdrawing/openings/SetByOthers";

export function OpeningBulkActions() {
    const confirm = useContext(ConfirmContext);
    const snack = useSnackbar();
    const edit = useContext(EditContext);

    const [move, setMove] = useState<{
        ids: number[];
        reset: () => void;
    }|null>(null)

    const [byOthers, setByOthers] = useState<{
        ids: number[];
        reset: () => void;
    }|null>(null)

    return (
        <>
            <MultiSelectRowHeader>
                {(close, ids, reset) => {
                    return (
                        <>
                            <MenuItem onClick={async () => {
                                close();

                                try {
                                    snack.loading();
                                    await api.quoteOpenings.bulkAction({
                                        ids: ids,
                                        action: "duplicate",
                                    });
                                    await edit.reload();
                                    snack.success("Updated");
                                    reset();
                                } catch (e: any) {
                                    snack.error(e.toString());
                                }
                            }}>
                                <ListItemText>Duplicate All</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={async () => {
                                close();
                                setMove({
                                    ids: ids,
                                    reset: reset,
                                })
                            }}>
                                <ListItemText>Move Selected</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={async () => {
                                close();
                                setByOthers({
                                    ids: ids,
                                    reset: reset,
                                })
                            }}>
                                <ListItemText>Set By-Us</ListItemText>
                            </MenuItem>
                            <MenuItem color="error" onClick={async () => {
                                const ok = await confirm.confirm("Are you sure you want to archive all selected items?")
                                if(!ok) return;

                                close();

                                try {
                                    snack.loading();
                                    await api.quoteOpenings.bulkAction({
                                        ids: ids,
                                        action: "archive",
                                    });
                                    await edit.reload();
                                    snack.success("Updated");
                                    reset();
                                } catch (e: any) {
                                    snack.error(e.toString());
                                }
                            }}>
                                <ListItemText style={{color: red["800"]}}>Archive All</ListItemText>
                            </MenuItem>
                        </>
                    )
                }}
            </MultiSelectRowHeader>
            {byOthers && <SetByOthers
                onCancel={() => setByOthers(null)}
                onSubmit={async (input) => {
                    await api.quoteOpenings.bulkAction({
                        ids: byOthers.ids,
                        action: "set-by-others",
                        door: input.door,
                        frame: input.frame,
                    });
                    await edit.reload();
                    const current = byOthers;
                    setByOthers(null);
                    current.reset();
                }} />}
            {move && <MoveSelectedOpenings
                ids={move.ids}
                onCancel={() => setMove(null)}
                onDone={() => {
                   setMove(null);
                   move.reset();
                }} />}
        </>
    )
}